/**
 * Limits shared by the Worker and the browser.
 *
 * They live here rather than in either side so the progress bar the customer
 * watches and the batch the server actually runs cannot drift apart.
 */

/**
 * Questions per model call. Small enough that a failure costs ten questions
 * rather than two hundred, and that the progress the customer sees is real.
 */
export const DRAFT_BATCH_LIMIT = 10;

/** Questions accepted from one spreadsheet import. */
export const MAX_QUESTIONS_PER_IMPORT = 500;
